import { auth } from "../firebase";
import { useAuthStore } from "../zustand/useAuthStore";

const AUTH_ERROR_CODES = [
  "permission-denied",
  "functions/permission-denied",
  "functions/unauthenticated",
] as const;

/**
 * Indica si el error corresponde a 403 / permisos insuficientes / no autenticado.
 */
export function isAuthError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const code = (error as { code?: string }).code;
  const message = String((error as { message?: string }).message ?? "").toLowerCase();
  if (code && AUTH_ERROR_CODES.includes(code as (typeof AUTH_ERROR_CODES)[number])) {
    return true;
  }
  if (message.includes("forbidden") || message.includes("403") ||
      message.includes("insufficient permissions") ||
      message.includes("missing or insufficient permissions")) {
    return true;
  }
  return false;
}

const LOGIN_PATH = "/login";

/**
 * Cierra sesión en Firebase Auth, limpia el store de auth y redirige a /login.
 * Usar cuando haya 403, permission-denied o unauthenticated.
 */
export function handleAuthError(): void {
  useAuthStore.getState().logout();
  auth.signOut().catch(() => {});
  window.location.href = LOGIN_PATH;
}
